// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.reducerComponent("EventLayer");

function getTouchData(touchesType, $$event) {
  var touch = Curry._1(touchesType, $$event).item(0);
  return /* float array */[
          touch.screenX,
          touch.screenY,
          Date.now()
        ];
}

function getGesture(start_, end_) {
  var speedDown = (end_[/* y */1] - start_[/* y */1]) * 10000.0 / (end_[/* time */2] - start_[/* time */2]);
  var speedRight = (end_[/* x */0] - start_[/* x */0]) * 10000.0 / (end_[/* time */2] - start_[/* time */2]);
  var isHoriz = +(Math.abs(speedRight) > Math.abs(speedDown));
  var match_000 = +(Math.abs(speedRight) - 4000.0 > 0.0);
  var match_001 = +(speedRight > 0.0);
  var match_000$1 = +(Math.abs(speedDown) - 4000.0 > 0.0);
  var match_001$1 = +(speedDown > 0.0);
  if (isHoriz !== 0) {
    if (match_000 !== 0) {
      if (match_001 !== 0) {
        return /* Some */[/* Right */1];
      } else {
        return /* Some */[/* Left */0];
      }
    } else {
      return /* None */0;
    }
  } else if (match_000$1 !== 0) {
    if (match_001$1 !== 0) {
      return /* Some */[/* Down */3];
    } else {
      return /* Some */[/* Up */2];
    }
  } else {
    return /* None */0;
  }
}

function setElemRef(theRef, param) {
  param[/* state */2][/* elementRef */1][0] = (theRef == null) ? /* None */0 : [theRef];
  return /* () */0;
}

function make(onAction, className, children) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = self[/* state */2][/* elementRef */1][0];
      if (match) {
        match[0].focus();
        return /* NoUpdate */0;
      } else {
        return /* NoUpdate */0;
      }
    });
  newrecord[/* render */9] = (function (param) {
      var reduce = param[/* reduce */1];
      var tmp = {
        ref: Curry._1(param[/* handle */0], setElemRef),
        tabIndex: 0,
        onTouchEnd: Curry._1(reduce, (function (e) {
                return /* TouchEnd */Block.__(1, [getTouchData((function (prim) {
                                  return prim.changedTouches;
                                }), e)]);
              })),
        onTouchMove: (function (e) {
            e.preventDefault();
            return /* () */0;
          }),
        onTouchStart: Curry._1(reduce, (function (e) {
                return /* TouchStart */Block.__(0, [getTouchData((function (prim) {
                                  return prim.targetTouches;
                                }), e)]);
              }))
      };
      if (className) {
        tmp.className = className[0];
      }
      return React.createElement("div", tmp, children);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* touchStart : None */0,
              /* elementRef */[/* None */0]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      var match = state[/* touchStart */0];
      if (action.tag) {
        if (match) {
          var match$1 = getGesture(match[0], action[0]);
          if (match$1) {
            var direction = match$1[0];
            return /* UpdateWithSideEffects */Block.__(3, [
                      /* record */[
                        /* touchStart : None */0,
                        /* elementRef */state[/* elementRef */1]
                      ],
                      (function () {
                          return Curry._1(onAction, direction);
                        })
                    ]);
          } else {
            return /* NoUpdate */0;
          }
        } else {
          return /* NoUpdate */0;
        }
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* touchStart : Some */[action[0]],
                    /* elementRef */state[/* elementRef */1]
                  ]]);
      }
    });
  return newrecord;
}

exports.component    = component;
exports.getTouchData = getTouchData;
exports.getGesture   = getGesture;
exports.setElemRef   = setElemRef;
exports.make         = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/EventLayer.re
// module id = 45
// module chunks = 0